import { render } from "./SampleCardFive.vue?vue&type=template&id=6c51b2c6"
import script from "./SampleCardFive.vue?vue&type=script&lang=js"
export * from "./SampleCardFive.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__